import { ge } from '../../utils/semver';
export var name = 'setupStayDialog';
export var supports = function (env) {
    var nativeToutiao = env.isInToutiao && !env.isCommercialWebview;
    if (!nativeToutiao) {
        return false;
    }
    var version = null;
    if (env.isIOS) {
        version = '6.7.0';
    }
    else {
        version = '6.7.1';
    }
    return ge(env.appVersion, version);
};
